// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import styles from './CreateProcedureCard.module.css';

interface CreateProcedureCardProps {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  iconClassName?: string;
  label: string;
  helperText: string;
  buttonLabel: string;
  onActionClick?: VoidFunction;
}

export function CreateProcedureCard({
  icon: Icon,
  iconClassName,
  label,
  helperText,
  buttonLabel,
  onActionClick,
}: CreateProcedureCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHead}>
        <Icon size={20} className={iconClassName} />
        <span className={styles.cardTitle}>{label}</span>
      </div>

      <div className={styles.dropzone}>
        <div className={styles.dropzoneTitle}>Upload a document</div>
        <div className={styles.dropzoneHelp}>{helperText}</div>
      </div>

      <div className={styles.divider}>
        <span>OR</span>
      </div>

      <button type="button" className={styles.blankButton} onClick={onActionClick}>
        {buttonLabel}
      </button>
    </div>
  );
}
